import {Attachment, FloorPlanOption} from "../SharedTypes";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {FormLabel, TextField} from "@material-ui/core";
import {Editor} from "@tinymce/tinymce-react";
import {WPMedia} from "./WPMedia";
import Button from "@material-ui/core/Button";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {inputStyles} from "../shared";

const useStyles = makeStyles({input: inputStyles});

export function FloorPlanOptionEditor({option, onChange, onSave, onBack}: {
    option: FloorPlanOption, onChange: (newOption: FloorPlanOption) => void
    onSave: () => any, onBack: () => any,
}) {
    const classes = useStyles();
    return <Grid container>
        <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>Edit Option {option.name}</Typography>
        </Grid>
        <Grid item xs={12}>
            <TextField id="name" label="Name" value={option.name} className={classes.input}
                       onChange={e => onChange({...option, name: e.target.value})}/>
        </Grid>
        <Grid item xs={12} md={6}>
            <div style={{margin: '1rem', marginLeft: 0}}>
                <FormLabel style={{display: 'block', marginBottom: '.5rem'}}>Description</FormLabel>
                <Editor
                    tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                    value={option.description}
                    onEditorChange={description => onChange({...option, description})}
                    init={{
                        height: 260,
                        menubar: false,
                        plugins: [
                            // 'advlist autolink lists link image charmap print preview anchor',
                            // 'searchreplace visualblocks code fullscreen',
                            // 'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar: 'undo redo | formatselect | ' +
                            'bold italic backcolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                    }}
                />
            </div>
        </Grid>
        <Grid item xs={12} md={6}>
            <WPMedia attachment={option.photo} label="Feature Image"
                     onChange={photo => onChange({...option, photo: photo as Attachment})}/>
        </Grid>

        <Grid item xs={12}>
            <div style={{marginTop: '2rem'}}>
                <Button color="primary" onClick={onBack}>
                    Back
                </Button>
                <Button variant="contained" color="primary"
                        onClick={onSave}>
                    Save
                </Button>
            </div>
        </Grid>
    </Grid>;
}